import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next'
import {toast} from "react-toastify";
import axios from "../../../axios-defaults";
import Alert from './Alert';

class Alerts extends PureComponent {
    constructor(props) {
        super(props);

        const {t} = this.props;

        this.state = {
            processed: false,
            toast_duration: 10000
        }
    }

    componentDidMount() {
        this.getAlerts();
    }

    async getAlerts () {
        await axios.get(`/alerts`)
            .then(response => {
                if (response.data.succeeded) {
                    this.setState({
                        alerts: response.data.data
                    })
                }
            }).catch(error => {
                toast.error(
                    <div>
                        <i className="fal fa-exclamation-circle"></i>&nbsp;{error.message}
                    </div>
                );

                console.log('[Alerts.js] : Ajax error in getAlerts()', error.message)
            });
    }

    render() {
        const {alerts} = this.state;

        return(
            <div>
                {alerts && alerts.danger?
                    Object.values(alerts.danger).map((item) => {
                        return <Alert type={"danger"} item={item} />
                    }):null}
                {alerts && alerts.warning?
                    Object.values(alerts.warning).map((item) => {
                        return <Alert type={"warning"} item={item} />
                    }):null}
                {alerts && alerts.success?
                    Object.values(alerts.success).map((item) => {
                        return <Alert type={"success"} item={item} />
                    }):null}
                {alerts && alerts.info?
                    Object.values(alerts.info).map((item) => {
                        return <Alert type={"info"} item={item} />
                    }):null}
            </div>);
    }
}

export default withTranslation()(Alerts);
